import { Component, Input, OnInit, OnDestroy, Inject, ViewChild, ElementRef } from '@angular/core';
import { ConceptModel, ProviderConceptModel } from './concept.model';
import { ConceptFamilyModel } from '../conceptfamily/conceptfamily.model';
import { EventEmitter } from '@angular/core';
import { Output, AfterContentChecked } from '@angular/core';
import { AccountsAndTaxesModel } from '../../invoice/preinvoice/accountsandtaxes.model';
import { InvoiceTaxModel } from '../../invoice/preinvoice/invoicetax.model';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ConceptComponent } from './concept.component';
import { ConceptService } from './concept.service';
import { Utils } from "../../../shared/utils";
import { GetUserInfo } from '../../../shared/utils';
import { consts } from '../../../consts';
import html2canvas from 'html2canvas';
import { DummyComponent } from '../../../shared/dummy.component';
import { Router } from '@angular/router';
import { FilesService } from '../../file/files.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { ContactModel } from '../../contact/contact/contact.model';
import { ContactService } from '../../contact/contact/contact.service';

@Component({
    selector: 'convfact-concept-form',
    templateUrl: './concept-form.component.html',
    styleUrls: ['./concept.component.css'],
    standalone: false
})

export class ConceptFormComponent implements OnInit, OnDestroy, AfterContentChecked {
  @Input() concept = new ConceptModel;
  @Input() families: ConceptFamilyModel;
  @Input() accountsAndTaxes: AccountsAndTaxesModel;
  @Input() taxes = Array<InvoiceTaxModel>();
  @Input() empty: boolean;
  chipsArray: [{}];

  public uid: string = this.data.uid;
  public example: boolean = this.data.example;
  public submitted = false;
  public ready = false;
  public haveStock = GetUserInfo.haveStock;

  public aux: number;
  public result: number;
  public taxesView: string[] = [];

  readOnly = false;
  barcodeInvalid = false;
  barcodeRenderError = false;

  @ViewChild('barcodePreview') barcodePreview: ElementRef<SVGElement>;

  pendingImage: File | null = null;
  pendingImageUrl = '';
  pendingImagePreview: SafeUrl | null = null;
  pendingFile: File | null = null;
  pendingFileUrl = '';
  pendingFilePreview: SafeResourceUrl | null = null;
  saving = false;
  imageReady = false;
  fileReady = false;
  path = 'files/Imagenes/Conceptos';
  urlImage: any;
  urlFile: any;
  sanitizedUrlFile: SafeResourceUrl;
  imgdUrlFile: SafeResourceUrl;
  providers: ContactModel[];
  relation: string[] = [];
  relationBBDD: ProviderConceptModel[];

  @Output() onSave = new EventEmitter<any>();
  @Input() errors: object;

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ConceptComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private conceptService: ConceptService,
    private fileService: FilesService,
    protected snackBar: MatSnackBar,
    private router: Router,
    public dummy: DummyComponent,
    private sanitizer: DomSanitizer,
    private contactService: ContactService
  ) { }

  async renderBarcode(value: string) {
    this.barcodeInvalid = false;
    this.barcodeRenderError = false;
    if (!value || !this.barcodePreview?.nativeElement) return;
    try {
      const JsBarcode = (await import('jsbarcode')).default;
      JsBarcode(this.barcodePreview.nativeElement, value, {
        format: 'CODE128',
        width: 2,
        height: 60,
        displayValue: true,
        fontSize: 13,
        margin: 8,
      });
    } catch (error) {
      // JsBarcode solo lanza InvalidInputException cuando el contenido no es
      // codificable en CODE128 (p.ej. caracteres fuera de rango ASCII 0-127).
      // Cualquier otro error (chunk de 'jsbarcode' que no cargó tras un
      // redeploy, fallo de red, etc.) no significa que el código introducido
      // sea inválido — mostrarlo como tal induce a error. Se distingue por
      // `error.name` y se deja constancia en consola para poder depurarlo.
      console.error('Error al generar el código de barras:', error);
      if ((error as { name?: string })?.name === 'InvalidInputException') {
        this.barcodeInvalid = true;
      } else {
        this.barcodeRenderError = true;
      }
    }
  }

  private scheduleRenderBarcode() {
    setTimeout(() => this.renderBarcode(this.concept.barcode), 0);
  }

  public closeDialog() {
    this.dialogRef.close();
  }

  async ngOnInit() {
    this.providers = await this.contactService.getListProviders();
    if (this.example == true) {
      this.concept = {
        name: 'pantalon vaquero',
        description: 'pantalon slim masculino',
        categoryName: 'ropa',
        categoryUid: '',
        codigoStock: '',
        costPrice: 20,
        discount: 0,
        limitUnits: 5,
        netPrice: 35,
        price: 35,
        shortcut: 'pv',
        taxes: [],
        uid: '',
        units: 10,
        barcode: "12345678901234567890",
        isStockEnabled: true,
        size: '',
        model: '',
        serialNumber: false,
        fileId: 0,
        imageId: 0,
        isTpv: false
      }
      this.ready = true;
      this.scheduleRenderBarcode();
      this.setTax(this.accountsAndTaxes.taxes[0], this.concept);
    } else if (this.uid !== null) {
      this.conceptService.loadData(this.uid).then(response => {
        this.concept = response;
        this.conceptService.getRelations(this.uid).then(response => {
          this.relationBBDD = response;
          this.relationBBDD.forEach(relation => {
            this.relation.push(relation.providerUid);
          })
        })
        if (this.concept.imageId != 0) {
          this.fileService.returnFileTPV(this.concept.imageId).then(response => {
            this.urlImage = response;
            this.imgdUrlFile = this.sanitizer.bypassSecurityTrustResourceUrl(this.urlImage);
            this.imageReady = true;
          })

        }
        if (this.concept.fileId != 0) {
          this.fileService.returnFileTPV(this.concept.fileId).then(response => {
            this.urlFile = response;
            this.sanitizedUrlFile = this.sanitizer.bypassSecurityTrustResourceUrl(this.urlFile);
            this.fileReady = true;
          });
        }
        this.ready = true;
        this.scheduleRenderBarcode();
      });
    } else {
      this.ready = true;
    }
  }

  public onSubmit() {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    if (this.concept.name == null) {
      this.displayInfo("El nombre es obligatorio");
      return;
    }

    this.concept.costPrice = Number(this.concept.costPrice);
    this.concept.netPrice = Number(this.concept.netPrice);
    this.concept.price = Number(this.concept.price);
    this.concept.units = Number(this.concept.units);
    this.concept.limitUnits = Number(this.concept.limitUnits);
    this.concept.discount = Number(this.concept.discount);

    if (isNaN(this.concept.discount)) {
      this.concept.discount = 0;
    }

    if (isNaN(this.concept.limitUnits)) {
      this.concept.limitUnits = 0;
    }

    if (isNaN(this.concept.units)) {
      this.concept.units = 0;
    }

    this.submitted = true;
    this.save(this.concept);
  }

  ngAfterContentChecked() {
    this.impuestos();
    this.calcularSubtotal();
    this.calcularTotal();
  }

  // Cuando seleccionas un proveedor
  addProviderUid(uid: any) {
    if (!uid || uid.trim() === '') {
      return;
    }
    if (!this.relation.includes(uid)) {
      this.relation.push(uid);
    }
  }

  // Para eliminar un proveedor de la lista
  removeProvider(uid: string) {
    this.relation = this.relation.filter(x => x !== uid);
  }

  // Mostrar el nombre en los badges
  getProviderName(uid: string) {
    const p = this.providers.find(x => x.uid === uid);
    return p ? p.companyName : '';
  }

  deleteFile(file: boolean, image: boolean) {
    let fileId = 0;
    const concept = this.concept;

    if (file) {
      fileId = this.concept.fileId;
      concept.fileId = 0;
    }
    if (image) {
      fileId = this.concept.imageId;
      concept.imageId = 0;
    }

    this.conceptService.editData(concept.uid, concept).then(response => {
      this.fileService.deleteFileTPV(fileId).then(response => {
        this.dummy.redirectTo(this.router.url);
      })
    })

  }

  upload(event: Event, type: 'image' | 'file') {
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files[0];
    input.value = '';
    if (!file) return;

    const extension = (file.name.split('.').pop() || '').toLowerCase();

    if (type === 'file') {
      if (extension !== 'pdf') {
        this.displayInfo('El fichero debe ser un PDF');
        return;
      }
      this.clearPendingFile();
      this.pendingFile = file;
      this.pendingFileUrl = URL.createObjectURL(file);
      this.pendingFilePreview = this.sanitizer.bypassSecurityTrustResourceUrl(this.pendingFileUrl);
      return;
    }

    if (!file.type.startsWith('image/')) {
      this.displayInfo('Selecciona una imagen (JPG, PNG…)');
      return;
    }

    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      if (img.naturalWidth <= 200 || img.naturalHeight <= 200) {
        URL.revokeObjectURL(url);
        this.displayInfo('La imagen debe ser superior a 200px');
        return;
      }
      this.clearPendingImage();
      this.pendingImage = file;
      this.pendingImageUrl = url;
      this.pendingImagePreview = this.sanitizer.bypassSecurityTrustUrl(url);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      this.displayInfo('No se pudo leer la imagen. Prueba con JPG o PNG');
    };
    img.src = url;
  }

  clearPendingImage() {
    if (this.pendingImageUrl) URL.revokeObjectURL(this.pendingImageUrl);
    this.pendingImage = null;
    this.pendingImageUrl = '';
    this.pendingImagePreview = null;
  }

  clearPendingFile() {
    if (this.pendingFileUrl) URL.revokeObjectURL(this.pendingFileUrl);
    this.pendingFile = null;
    this.pendingFileUrl = '';
    this.pendingFilePreview = null;
  }

  ngOnDestroy() {
    this.clearPendingImage();
    this.clearPendingFile();
  }

  async generatePDF() {
    const barcodeElement = document.getElementById('barcodeContainer');

    if (!barcodeElement) {
      console.error('No se encontró el contenedor del código de barras.');
      return;
    }

    const { jsPDF } = await import('jspdf');
    html2canvas(barcodeElement).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      const pageHeight = pdf.internal.pageSize.height;
      const barcodeHeight = 30; // Altura del código de barras
      const spacing = 10; // Espacio entre código y texto
      const textHeight = 7; // Espacio adicional para el texto
      let y = 20;

      for (let i = 0; i < this.concept.units; i++) {
        if (y + barcodeHeight + textHeight > pageHeight - 20) {
          pdf.addPage();
          y = 20;
        }

        // Agregar imagen del código de barras
        pdf.addImage(imgData, 'PNG', 10, y, 100, barcodeHeight);

        // Texto debajo del código de barras
        const codeText = `${this.concept.barcode}`;
        pdf.setFontSize(10);
        pdf.text(codeText, 10, y + barcodeHeight + 5);

        y += barcodeHeight + textHeight + spacing;
      }

      pdf.output('dataurlnewwindow');
    });
  }

  public impuestos() {
    this.taxesView = [];
    if (this.concept.taxes != undefined) {
      this.result = this.concept.netPrice;
      this.concept.taxes.forEach(tax => {
        if (this.result != 0) {
          this.aux = (tax.taxImport / 100) * this.result;
          this.taxesView.push(tax.name + ' : ' + Utils.GetValueWithDecimals(this.aux));
        }
      });
    }
  }

  public calcularSubtotal() {
    const netPrice = Number(this.concept.netPrice || 0);
    const discount = Number(this.concept.discount || 0);
    //const units = Number(this.concept.units || 1);

    //const base = netPrice * units;
    const base = netPrice
    const discounted = base * (1 - discount / 100);

    return Utils.GetValueWithDecimals(discounted);
  }

  public calcularTotal() {
    const subtotal = Number(this.calcularSubtotal());
    this.result = subtotal;

    if (this.concept.taxes != undefined) {
      this.concept.taxes.forEach(tax => {
        this.aux = (tax.taxImport / 100) * subtotal;
        this.result += this.aux;
      });
    }

    this.concept.price = Utils.GetValueWithDecimals(this.result);
    return this.concept.price;
  }

  public setTax(tax: InvoiceTaxModel, concept: ConceptModel): void {
    tax.taxId = tax.id;
    tax.id = 0;

    const alreadyApplied = concept.taxes.some(t => t.taxId === tax.taxId || t.uid === tax.uid);
    if (alreadyApplied) {
      this.displayInfo('Este impuesto ya ha sido aplicado.');
      return;
    }

    const isRecargoEquiv = tax.name.toLowerCase().includes('recargo equiv');
    const impuestosPrincipalesDelMismoTipo = concept.taxes.filter(t =>
      t.type === tax.type && !t.name.toLowerCase().includes('recargo equiv')
    );

    if (!isRecargoEquiv && impuestosPrincipalesDelMismoTipo.length > 0) {
      this.displayInfo(`Ya se ha aplicado un impuesto principal del tipo ${tax.type}.`);
      return;
    }

    const isInversionSP = tax.name.includes("Inversión S.P.");
    const hasInversionSP = concept.taxes.some(t => t.name.includes("Inversión S.P."));
    if (isInversionSP && hasInversionSP) {
      this.displayInfo('Ya se ha aplicado un impuesto de Inversión S.P.');
      return;
    }

    concept.taxes.push(tax);
  }

  public changeChips(element: ConceptFormComponent) {
    element.taxes.forEach(tax => {
      element.setTax(tax, element.concept);
    });

  }

  onSelectTax(data: any) {
    this.setTax(this.accountsAndTaxes.taxes.filter(c => c.id == data)[0], this.concept)
  }

  save(concept: ConceptModel) {
    if (this.saving) return;
    this.saving = true;
    this.uploadPending(concept).then(() => this.saveData(concept));
  }

  private async uploadPending(concept: ConceptModel): Promise<void> {
    const baseName = (concept.name || 'concepto') + '_' + Date.now();

    if (this.pendingImage) {
      try {
        const response = await this.fileService.createFileId(this.pendingImage, 'Image', baseName + '_imagen', this.path);
        const imageId = this.uploadedFileId(response);
        if (imageId) {
          concept.imageId = imageId;
        } else {
          this.displayInfo(response?.message || 'No se pudo subir la imagen');
        }
      } catch {
        this.displayInfo('No se pudo subir la imagen');
      }
    }

    if (this.pendingFile) {
      try {
        const response = await this.fileService.createFileId(this.pendingFile, 'PDF', baseName + '_documento', this.path);
        const fileId = this.uploadedFileId(response);
        if (fileId) {
          concept.fileId = fileId;
        } else {
          this.displayInfo(response?.message || 'No se pudo subir el fichero');
        }
      } catch {
        this.displayInfo('No se pudo subir el fichero');
      }
    }
  }

  private uploadedFileId(response: any): number {
    if (!response || response.error === true) {
      return 0;
    }
    const id = response.id ?? response.data?.id ?? response.data;
    return typeof id === 'number' && id > 0 ? id : 0;
  }

  saveData(concept) {
    if (concept.uid == null) {
      this.conceptService.addData(concept)
        .then(concept => {
          this.conceptService.addRelation(concept.uid, this.relation);
          this.concept = concept;
          this.dummy.redirectTo(this.router.url);
          this.closeDialog();
        })
        .catch(errors => {
          this.saving = false;
          this.displayInfo(errors?.error?.message || 'No se pudo guardar el concepto');
        });
    } else {
      this.conceptService.editData(concept.uid, concept)
        .then(concept => {
          this.conceptService.editRelation(concept.uid, this.relation);
          this.concept = concept;
          this.dummy.redirectTo(this.router.url);
          this.closeDialog();
        })
        .catch(errors => {
          this.saving = false;
          this.displayInfo(errors?.error?.message || 'No se pudo guardar el concepto');
        });
    }
  }

  public setValueStockControl(event: MatSlideToggleChange) {
    if (event.checked === false && this.concept.serialNumber === true) {
      this.concept.serialNumber = false;
    }
    this.concept.isStockEnabled = event.checked;
  }

  public setValueSerialNumbers(event: MatSlideToggleChange) {
    this.concept.serialNumber = event.checked;
    this.concept.isStockEnabled = event.checked;
  }
  public setValueIsTpv(event: MatSlideToggleChange) {
    this.concept.isTpv = event.checked;
  }

  serialNumbers(uid: string) {
    alert(uid);
  }

  showTemplate() {
    this.dialog.open(ConceptComponent, {
      width: '60%',
      height: '70%',
      data: { example: true }
    });
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  public trackByIndex(i: number) { return i; }

}
